/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { RowSkeleton } from '../../skeletons/RowSkeleton';
import { useDescriptionPanelStyles } from '../../styles/descriptionPanel';

export const DescriptionPanelLoader = memo(() => {
  const classes = useDescriptionPanelStyles();

  return (
    <>
      <div className={classes.panelIconWrapper}>
        <div className={classes.itemIcon}>
          <RowSkeleton width={56} height={56} />
        </div>
      </div>
      <div className={classes.panelTitle}>
        <RowSkeleton width={110} height={28} />
      </div>
      <div className={classes.panelEditWrapper}>
        <RowSkeleton width={21} height={21} />
        <RowSkeleton width={21} height={21} />
        <RowSkeleton width={21} height={21} />
      </div>
    </>
  );
});
